export const INACTIVE_PROGRAMS = ["scale", "angels"];
